import firebase from "firebase/app";
import "firebase/app";
import "firebase/performance";

// Initialize Firebase app
// local

firebase.initializeApp({
  apiKey: "AIzaSyABMQJLZkns8-CdR0zwdYw6Fm8a7FRBjpI",
  authDomain: "aamcart-ecommerce.firebaseapp.com",
  databaseURL: "https://aamcart-ecommerce.firebaseio.com",
  projectId: "aamcart-ecommerce",
  storageBucket: "aamcart-ecommerce.appspot.com",
  messagingSenderId: "65004932717",
  appId: "1:65004932717:web:e2049575b1ee43024f7964",
  measurementId: "G-9K3Y2R9ZX4"
});

firebase.performance();
// live

// firebase.initializeApp({
//   apiKey: "AIzaSyAWxcs4d_r1nhrKxKf_OjYiNJWZm_TFKgU",
//   authDomain: "krishak-ecommerce.firebaseapp.com",
//   databaseURL: "https://krishak-ecommerce.firebaseio.com",
//   projectId: "krishak-ecommerce",
//   storageBucket: "krishak-ecommerce.appspot.com",
//   messagingSenderId: "401105495081",
//   appId: "1:401105495081:web:262ea1bf60f7e05cb9e838",
//   measurementId: "G-2XEPVRMNQ2"
// });
